function encodeObjectToBase64(obj: object): string {
    const replacer = (key: string, value: string | number) =>
        typeof value === "string" ? value.replace(/\n/g, " ") : value;
    return btoa(JSON.stringify(obj, replacer));
}

function decodeBase64ToObject(base64: string): object {
    return JSON.parse(atob(base64));
}

export { encodeObjectToBase64, decodeBase64ToObject };
